<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      title="优惠券详情"
      @click-left="goableBack()"
      :z-index="10"></van-nav-bar>
    <div class="view-bg">
      <div class="mian-bg">
        <div class="top-bg">
          <div class="title">{{ couponItem.name }}</div>
          <div class="date">
            有效期&nbsp;&nbsp;
            {{ dateFormat(couponItem.takeEffectTime, "YYYY-MM-DD") }} 至
            {{ dateFormat(couponItem.expiryTime, "YYYY-MM-DD") }}
          </div>
          <van-button
            class="btn-bg"
            round
            color="rgb(190,157,118)"
            @click="onCommitUse"
            >立即使用</van-button
          >
        </div>
        <div class="rule-bg">
          <h4>｜使用规则</h4>
          <div class="rule-info" v-html="ruleHtml"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { preExperienceProduct } from "../../api/product"
import session from "../../utils/session"
export default {
  data() {
    return {
      couponItem: {},
      ruleHtml: ""
    }
  },
  mounted() {
    this.couponItem = JSON.parse(session.getJson("perienceKey")) || {}
    this.ruleHtml =
      "【权益名称】：<br />体验金产品" +
      this.couponItem.amount +
      "元体验金<br />【使用规则】：<br /> 1、体验金有效期限以客户收到的体验金券显示的有效期限为准，根据不同的体验金活动，有效期限也会有所不同。<br /> 2、请在有效期内使用，过期将自动失效处理。<br /> 3、体验金只能用于购买指定体验资产，体验金不能提现或转让，通过体验金参与指定体验资产期限满后，天安金交中心收回体验金；通过体验金参与指定体验资产所产生的收益归客户所有，客户可用于在平台进行投资时抵扣，不可以提现或转让。<br />4、通过体验金参与指定体验资产获得的体验金收益自发放日起6个月内有效，请在有效期内使用，过期将自动失效。<br />【注意事项】：<br /> 1、体验金是天安金交中心平台推出的一项投资体验服务，主要是为帮助客户熟悉和了解天安金交中心平台的操作，包括页面操作流程，资产认购流程和资产查询流程及收益结算流程，客户后续可以根据自己的需求和风险承受能力选择合适的资产。<br /> 2、天安金交中心对体验金拥有最终解释权。"
  },
  methods: {
    onCommitUse() {
      this._showLoading()
      preExperienceProduct()
        .then((data) => {
          this._dismissLoading()
          this.$router.push({
            path: "/detail",
            query: { productId: data }
          })
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.view-bg {
  min-height: calc(100vh - 45px);
  .mian-bg {
    padding: 15px 10px 20px 10px;
    .top-bg {
      background-color: white;
      padding: 15px;
      padding-bottom: 25px;
      border-radius: 8px;
      -moz-box-shadow: 2px 2px 5px rgb(235, 235, 235);
      -webkit-box-shadow: 2px 2px 5px rgb(235, 235, 235);
      box-shadow: 2px 2px 10px rgb(235, 235, 235);
      text-align: center;
      .title {
        font-size: 20px;
        font-weight: 900;
        padding-bottom: 5px;
        border-bottom: 1px dashed rgb(235, 235, 235);
      }
      .date {
        margin: 20px 0;
        text-align: left;
      }
      .btn-bg {
        border-radius: 16px;
      }
    }
    .rule-bg {
      background-color: white;
      margin-top: 10px;
      padding: 3px 15px;
      padding-bottom: 20px;
      border-radius: 8px;
      -moz-box-shadow: 2px 2px 5px rgb(235, 235, 235);
      -webkit-box-shadow: 2px 2px 5px rgb(235, 235, 235);
      box-shadow: 2px 2px 10px rgb(235, 235, 235);
      h4 {
        margin-bottom: 0px;
      }
      .rule-info {
        padding: 0 5px;
        line-height: 25px;
      }
    }
  }
}
</style>